// extracted by mini-css-extract-plugin
export var authorSocialSectionWrapperStyle = "blog_post_author_social_section-module--authorSocialSectionWrapperStyle--pGqjm";